import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LIMIT } from "../utils/constants/listFilters";

/** Page (1-based in the URL) and page size, kept in the URL so they survive back navigation. */
export default function useUrlPaging() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(() => {
    const n = parseInt(searchParams.get("page"), 10);
    return Number.isInteger(n) && n > 1 ? n - 1 : 0;
  });
  const [pageSize, setPageSize] = useState(() => {
    const n = parseInt(searchParams.get("page_size"), 10);
    return Number.isInteger(n) && n > 0 ? n : LIMIT;
  });

  useEffect(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (page > 0) next.set("page", String(page + 1));
        else next.delete("page");
        if (pageSize !== LIMIT) next.set("page_size", String(pageSize));
        else next.delete("page_size");
        return next;
      },
      { replace: true }
    );
  }, [page, pageSize, setSearchParams]);

  return { page, setPage, pageSize, setPageSize };
}
